import { Joi } from 'app-webtech-core/schemas';
import { subselect } from './root';

const isValidDeviceStateSchemaValidator = Joi.object()
  .unknown()
  .keys({
    ID: Joi.string().not('not-defined').required(),
    isConfigured: Joi.boolean().only(true).required(),
    error: Joi.any().only(null),
  });

const assertSelector = (deviceState) => {
  const { error } = Joi.validate(deviceState, isValidDeviceStateSchemaValidator);
  return !error;
};

export const deviceIsValidSelector = subselect(assertSelector);
